import React, { useEffect, useState } from "react";
import { database } from "../firebase/firebase";
import { ref, onValue, update, push } from "firebase/database";

const Admin = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [deposits, setDeposits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingProfits, setProcessingProfits] = useState(false);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = () => {
    const usersRef = ref(database, "users");

    onValue(usersRef, (snapshot) => {
      const usersData = snapshot.val();
      const allWithdrawals = [];
      const allDeposits = [];

      if (usersData) {
        Object.entries(usersData).forEach(([userId, user]) => {
          if (user.deposits) {
            Object.entries(user.deposits).forEach(([key, deposit]) => {
              allDeposits.push({ ...deposit, userId, key });
            });
          }
          if (user.withdrawals) {
            Object.entries(user.withdrawals).forEach(([key, withdrawal]) => {
              allWithdrawals.push({ ...withdrawal, userId, key });
            });
          }
        });
      }

      setDeposits(allDeposits);
      setWithdrawals(allWithdrawals);
      setLoading(false);
    });
  };

  const confirmDeposit = (deposit) => {
    const { userId, key, usdAmount } = deposit;

    update(ref(database, `users/${userId}/deposits/${key}`), {
      status: "Confirmed",
      startDate: new Date().toISOString(),
      lastProfitDate: new Date().toISOString(),
    });

    let profitAmount = 0;
    let duration = 0;

    if ([2400, 2900, 3400].includes(usdAmount)) {
      profitAmount = usdAmount * 0.1;
      duration = 30;
    } else if ([900, 1400, 1900].includes(usdAmount)) {
      profitAmount = usdAmount * 0.05;
      duration = 90;
    } else if ([5900, 7900, 9900].includes(usdAmount)) {
      profitAmount = usdAmount * 0.2;
      duration = 90;
    } else if (usdAmount === 50000) {
      profitAmount = usdAmount * 0.02;
      duration = 365;
    }

    update(ref(database, `users/${userId}/deposits/${key}`), {
      dailyProfit: profitAmount,
      duration: duration,
    });
  };

  const distributeProfits = async () => {
    setProcessingProfits(true);
    const usersRef = ref(database, "users");

    onValue(
      usersRef,
      (snapshot) => {
        const usersData = snapshot.val();
        if (!usersData) {
          setProcessingProfits(false);
          return;
        }

        Object.entries(usersData).forEach(async ([userId, user]) => {
          if (user.deposits) {
            Object.entries(user.deposits).forEach(async ([key, deposit]) => {
              if (deposit.status === "Confirmed") {
                const dailyProfit = deposit.dailyProfit || 0;

                // Add profit to the user's balance
                await push(ref(database, `users/${userId}/profits`), {
                  usdAmount: dailyProfit,
                  date: new Date().toISOString(),
                  plan: deposit.plan,
                  status: deposit.status,
                });

                await update(ref(database, `users/${userId}`), {
                  balance: (user.balance || 0) + dailyProfit,
                });
              }
            });
          }
        });

        setProcessingProfits(false);
        alert("Daily profits distributed successfully!");
      },
      { onlyOnce: true }
    );
  };
  const confirmWithdrawal = (withdrawal) => {
    const { userId, key, usdAmount } = withdrawal;

    const userRef = ref(database, `users/${userId}`);
    onValue(
      userRef,
      (snapshot) => {
        const userData = snapshot.val();
        if (userData) {
          const newBalance = (userData.balance || 0) - usdAmount;
          update(userRef, { balance: newBalance });
        }
      },
      { onlyOnce: true }
    );

    update(ref(database, `users/${userId}/withdrawals/${key}`), {
      status: "Confirmed",
    });
  };

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Admin Panel</h1>

      <button
        onClick={distributeProfits}
        className="mt-4 bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600 disabled:opacity-50"
        disabled={processingProfits}
      >
        {processingProfits ? "Processing..." : "Distribute Profits"}
      </button>

      <div className="mt-6">
        <h2 className="text-xl font-semibold">Deposits</h2>
        <ul>
          {deposits
            .slice()
            .reverse()
            .map((deposit) => (
              <li
                key={deposit.key}
                className="flex justify-between p-2 border mb-2 rounded-lg"
              >
                <span>
                  {deposit.plan} - ${deposit.usdAmount}
                </span>
                <button
                  onClick={() => confirmDeposit(deposit)}
                  className={`${
                    deposit.status === "Confirmed"
                      ? "bg-green-500 cursor-not-allowed"
                      : "bg-blue-500 hover:bg-blue-600"
                  } text-white px-4 py-2 rounded transition-all disabled:opacity-50`}
                  disabled={deposit.status === "Confirmed"}
                >
                  {deposit.status === "Confirmed" ? "Confirmed" : "Confirm"}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="mt-6">
        <h2 className="text-xl font-semibold">Withdrawals</h2>
        <ul>
          {withdrawals.map((withdrawal) => (
            <li
              key={withdrawal.key}
              className="flex justify-between p-2 border mb-2 rounded-lg"
            >
              <span>${withdrawal.usdAmount}</span>
              <button
                onClick={() => confirmWithdrawal(withdrawal)}
                className={`${
                  withdrawal.status === "Confirmed"
                    ? "bg-green-500 cursor-not-allowed"
                    : "bg-red-500 hover:bg-red-600"
                } text-white px-4 py-2 rounded transition-all disabled:opacity-50`}
                disabled={withdrawal.status === "Confirmed"}
              >
                {withdrawal.status === "Confirmed" ? "Confirmed" : "Confirm"}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Admin;
